import Thread_Bangle from "../assests/images/thread_bangle.jpeg";
import Bridal_Bangle from "../assests/images/bridal_set.jpeg";
import Hair_Accessory from "../assests/images/hair_accessory.png";
import Royal_Pink_Bangle_Set from "../assests/images/pink_royal_thread_bangle_set.jpeg";
import Golden_Bridal_Heritage_Set from "../assests/images/golden_bridal_heritage_set.jpeg";
import Hair_Clips from "../assests/images/hair_clips.jpeg";
import Ear_Rings from "../assests/images/ear_rings.jpeg";
import Invisible_Chain from "../assests/images/invisible-chain.png";
import Chain_Set from "../assests/images/chiain-set.png";
import Chain_2 from "../assests/images/chain_2.jpeg";
import Chain_3 from "../assests/images/chain_3.jpeg";
import Chain_4 from "../assests/images/chain_4.jpeg";
import Hair_Clip_1 from "../assests/images/hair_clip_1.jpeg";
import Hair_Clip_2 from "../assests/images/hair_clip_2.jpeg";
import Hair_Clip_3 from "../assests/images/hair_clip_3.jpeg";
import Hair_Clip_4 from "../assests/images/hair_clip_4.jpeg";
import Hair_Clip_5 from "../assests/images/hair_clip_5.jpeg";
import Hair_Clip_6 from "../assests/images/hair_clip_6.jpeg";
import Hair_Clip_7 from "../assests/images/hair_clip_7.jpeg";
import Hair_Clip_8 from "../assests/images/hair_clip_8.jpeg";
import Hair_Clip_9 from "../assests/images/hair_clip_9.png";

import Invisible_Chain_1 from "../assests/images/invisible chain 1.jpeg";
import Invisible_Chain_2 from "../assests/images/invisible chain 2.jpeg";
import Invisible_Chain_3 from "../assests/images/invisible chain 3.jpeg";
import Invisible_Chain_4 from "../assests/images/invisible chain 4.jpeg";
import Invisible_Chain_5 from "../assests/images/invisible chain 5.jpeg";
import Invisible_Chain_6 from "../assests/images/invisible chain 6.jpeg";
import Invisible_Chain_7 from "../assests/images/invisible chain 7.jpeg";
import Invisible_Chain_8 from "../assests/images/invisible chain 8.jpeg";
import Invisible_Chain_9 from "../assests/images/invisible chain 9.jpeg";
import Invisible_Chain_10 from "../assests/images/invisible chain 10.jpeg";
import Invisible_Chain_11 from "../assests/images/invisible chain 11.jpeg";
import Invisible_Chain_12 from "../assests/images/invisible chain 12.jpeg";
import Invisible_Chain_13 from "../assests/images/invisible chain 13.jpeg";
import Invisible_Chain_15 from "../assests/images/invisible chain 15.jpeg";
import Invisible_Chain_17 from "../assests/images/invisible chain 17.jpeg";
import Invisible_Chain_18 from "../assests/images/invisible chain 18.jpeg";
import Thread_Bangle_1 from "../assests/images/thread_bangle_1.jpeg";
import Thread_Bangle_2 from "../assests/images/thread_bangle_2.jpeg";
import Thread_Bangle_3 from "../assests/images/thread_bangle_3.jpeg";
import Thread_Bangle_4 from "../assests/images/thread_bangle_4.jpeg";
import Thread_Bangle_5 from "../assests/images/thread_bangle_5.jpeg";
import Thread_Bangle_6 from "../assests/images/thread_bangle_6.jpeg";
import Thread_Bangle_7 from "../assests/images/thread_bangle_7.jpeg";
import Thread_Bangle_8 from "../assests/images/thread_bangle_8.jpeg";
import Thread_Bangle_9 from "../assests/images/thread_bangle_9.jpeg";
import Thread_Bangle_10 from "../assests/images/thread_bangle_10.jpeg";
import Thread_Bangle_12 from "../assests/images/thread_bangle_12.jpeg";
import Thread_Bangle_13 from "../assests/images/thread_bangle_13.jpeg";
import Thread_Bangle_14 from "../assests/images/thread_bangle_14.jpeg";
import Thread_Bangle_15 from "../assests/images/thread_bangle_15.jpeg";
import Thread_Bangle_16 from "../assests/images/thread_bangle_16.jpeg";
import Thread_Bangle_17 from "../assests/images/thread_bangle_17.jpeg";
import Thread_Bangle_18 from "../assests/images/thread_bangle_18.jpeg";
import Thread_Bangle_19 from "../assests/images/thread_bangle_19.jpeg";
import Thread_Bangle_20 from "../assests/images/thread_bangle_20.jpeg";
import Thread_Bangle_21 from "../assests/images/thread_bangle_21.jpeg";
import Thread_Bangle_22 from "../assests/images/thread_bangle_22.jpeg";
import Thread_Bangle_23 from "../assests/images/thread_bangle_23.jpeg";
import Thread_Bangle_24 from "../assests/images/thread_bangle_24.jpeg";
import Thread_Bangle_25 from "../assests/images/thread_bangle_25.jpeg";
import Thread_Bangle_26 from "../assests/images/thread_bangle_26.png";
import Thread_Bangle_27 from "../assests/images/thread_bangle_27.jpeg";
import Bridal_Set_1 from "../assests/images/bridal_set_1.jpeg";
import Bridal_Set_2 from "../assests/images/bridal_set_2.jpeg";
import Bridal_Set_3 from "../assests/images/bridal_set_3.jpeg";
import Bridal_Set_4 from "../assests/images/bridal_set_4.jpeg";
import Bridal_Set_5 from "../assests/images/bridal_set_5.jpeg";
import Bridal_Set_6 from "../assests/images/bridal_set_6.jpeg";
import Bridal_Set_7 from "../assests/images/bridal_set_7.jpeg";
import Bridal_Set_8 from "../assests/images/bridal_set_8.jpeg";
import Bridal_Set_9 from "../assests/images/bridal_set_9.jpeg";
import Bridal_Set_10 from "../assests/images/bridal_set_10.jpeg";
import Bridal_Set_11 from "../assests/images/bridal_set_11.jpeg";
import Bridal_Set_12 from "../assests/images/bridal_set_12.jpeg";
import Bridal_Set_13 from "../assests/images/bridal_set_13.jpeg";
import Bridal_Set_14 from "../assests/images/bridal_set_14.jpeg";
import Bridal_Set_15 from "../assests/images/bridal_set_15.jpeg";
import Bridal_Set_17 from "../assests/images/bridal_set_17.png";
import Bridal_Set_18 from "../assests/images/bridal_set_18.png";
import Bridal_Set_19 from "../assests/images/bridal_set_19.jpeg";
import Bridal_Set_20 from "../assests/images/bridal_set_20.jpeg";
import Bridal_Set_21 from "../assests/images/bridal_set_21.jpeg";

import Saree_Pin from "../assests/images/saree_pin.jpeg";

export const collectionProducts = {
  "thread-bangles": {
    // Thread Bangles
    name: "Thread Bangles",
    products: [
      {
        id: 101,
        name: "Classic Thread Bangles",
        description: "Vibrant handwoven thread bangles in stunning color combinations.",
        price: "₹79",
        image: Thread_Bangle_1,
      },
      {
        id: 102,
        name: "Royal Sky Blue Bangles Set of 2",
        description: "A regal set of handwoven pink thread bangles with gold accent detailing.",
        price: "₹199",
        image: Thread_Bangle_2,
      },
      {
        id: 103,
        name: "Multi-Color Thread Bangles(single set)",
        description: "Colorful thread bangles perfect for festive occasions.",
        price: "₹249",
        image: Thread_Bangle_3,
      },
      {
        id: 104,
        name: "Elegant Thread Bangle Set",
        description: "Sophisticated thread bangles with intricate patterns.",
        price: "₹199",
        image: Thread_Bangle_4,
      },
      {
        id: 105,
        name: "Designer Thread Bangles",
        description: "Premium quality thread bangles with designer embellishments.",
        price: "₹349",
        image: Thread_Bangle_5,
      },
      {
        id: 106,
        name: "Traditional Thread Bangles",
        description: "Traditional style thread bangles for everyday wear.",
        price: "₹199",
        image: Thread_Bangle_6,
      },
      {
        id: 107,
        name: "Festive Thread Bangles",
        description: "Beautiful thread bangles perfect for celebrations.",
        price: "₹249",
        image: Thread_Bangle_7,
      },
      {
        id: 108,
        name: "Premium Thread Bangle Set",
        description: "Premium quality bangles with intricate threadwork.",
        price: "₹279",
        image: Thread_Bangle_8,
      },
      {
        id: 109,
        name: "Bridal Thread Bangles",
        description: "Elegant bangles designed for bridal occasions.",
        price: "₹279",
        image: Thread_Bangle_9,
      },
      {
        id: 110,
        name: "Contemporary Thread Bangles",
        description: "Modern design thread bangles for fashion-forward looks.",
        price: "₹149",
        image: Thread_Bangle_10,
      },
      
      {
        id: 112,
        name: "Luxury Thread Bangle Set",
        description: "Luxurious bangles with premium materials and finish.",
        price: "₹199",
        image: Thread_Bangle_12,
      },
      {
        id: 113,
        name: "Artistic Thread Bangles",
        description: "Artistic designs with unique color combinations.",
        price: "₹299",
        image: Thread_Bangle_13,
      },
      {
        id: 114,
        name: "Minimalist Thread Bangles",
        description: "Simple yet elegant minimalist design bangles.",
        price: "₹599",
        image: Thread_Bangle_14,
      },
      {
        id: 115,
        name: "Vibrant Thread Bangles",
        description: "Vibrant colors perfect for any occasion.",
        price: "₹649",
        image: Thread_Bangle_15,
      },
      {
        id: 116,
        name: "Pearl Thread Bangles",
        description: "Thread bangles with elegant pearl embellishments.",
        price: "₹149",
        image: Thread_Bangle_16,
      },
      {
        id: 117,
        name: "Colorful Thread Bangles(set of 4)",
        description: "Colorful thread bangles with traditional appeal.",
        price: "₹199",
        image: Thread_Bangle_17,
      },
      {
        id: 118,
        name: "Ethnic Thread Bangles(set of 2)",
        description: "Ethnic design perfect for cultural celebrations.",
        price: "₹149",
        image: Thread_Bangle_18,
      },
      {
        id: 119,
        name: "Delicate Thread Bangles set",
        description: "Delicate and refined thread bangles.",
        price: "₹149",
        image: Thread_Bangle_19,
      },
      {
        id: 120,
        name: "Ornate Thread Bangles set",
        description: "Ornate designs with detailed craftsmanship.",
        price: "₹259",
        image: Thread_Bangle_20,
      },
      {
        id: 121,
        name: "Sophisticated Thread Bangles(set of 1)",
        description: "Sophisticated style for elegant occasions.",
        price: "₹129",
        image: Thread_Bangle_21,
      },
      {
        id: 122,
        name: "Charming Thread Bangles set",
        description: "Charming designs that capture attention.",
        price: "₹249",
        image: Thread_Bangle_22,
      },
      {
        id: 123,
        name: "Graceful Thread Bangles(set of 2)",
        description: "Graceful bangles with timeless appeal.",
        price: "₹79",
        image: Thread_Bangle_23,
      },
      {
        id: 124,
        name: "Exquisite Thread Bangles",
        description: "Exquisite craftsmanship in every detail.",
        price: "₹399",
        image: Thread_Bangle_24,
      },
    
      {
        id: 126,
        name: "Stunning Thread Bangles(set of 4)",
        description: "Stunning designs for special moments.",
        price: "₹349",
        image: Thread_Bangle_26,
      },
      // {
      //   id: 127,
      //   name: "Magnificent Thread Bangles",
      //   description: "Magnificent bangles for grand occasions.",
      //   price: "₹599",
      //   image: Thread_Bangle_27,
      // },
    ],
  },
  "bridal-bangle-sets": {
    // Bridal Bangle Sets
    name: "Bridal Bangle Sets",
    products: [
      {
        id: 201,
        name: "Golden Bridal Heritage Set",
        description: "An opulent bridal bangle set featuring intricate gold threadwork and pearl embellishments.",
        price: "₹799",
        image: Bridal_Set_1,
      },
      {
        id: 202,
        name: "Classic Bridal Set",
        description: "Exquisite bridal sets crafted for the most special day.",
        price: "₹899",
        image: Bridal_Set_2,
      },
      {
        id: 203,
        name: "Royal Bridal Collection",
        description: "Luxurious bridal bangles with traditional craftsmanship.",
        price: "₹1299",
        image: Bridal_Set_3,
      },
      {
        id: 204,
        name: "Premium Bridal Set",
        description: "Premium bridal bangles with gold and pearl work.",
        price: "₹899",
        image: Bridal_Set_4,
      },
      {
        id: 205,
        name: "Designer Bridal Bangles",
        description: "Contemporary bridal bangles with modern design elements.",
        price: "₹999",
        image: Bridal_Set_5,
      },
      {
        id: 206,
        name: "Elegant Bridal Collection(set of 2)",
        description: "Elegant bridal bangles perfect for wedding ceremonies.",
        price: "₹999",
        image: Bridal_Set_6,
      },
      {
        id: 207,
        name: "Traditional Bridal Set",
        description: "Traditional bridal bangles with heritage designs.",
        price: "₹1299",
        image: Bridal_Set_7,
      },
      {
        id: 208,
        name: "Luxury Bridal Collection",
        description: "Luxury bridal bangles for grand celebrations.",
        price: "₹1299",
        image: Bridal_Set_8,
      },
      {
        id: 209,
        name: "Regal Bridal Set",
        description: "Regal bridal bangles with royal elegance.",
        price: "₹1399",
        image: Bridal_Set_9,
      },
      {
        id: 210,
        name: "Majestic Bridal Bangles",
        description: "Majestic designs for the perfect bridal look.",
        price: "₹1099",
        image: Bridal_Set_10,
      },
      {
        id: 211,
        name: "Opulent Bridal Set",
        description: "Opulent bridal bangles with rich embellishments.",
        price: "₹849",
        image: Bridal_Set_11,
      },
      {
        id: 212,
        name: "Graceful Bridal Collection",
        description: "Graceful bridal bangles for elegant brides.",
        price: "₹1399",
        image: Bridal_Set_12,
      },
      {
        id: 213,
        name: "Exquisite Bridal Set",
        description: "Exquisite craftsmanship for your special day.",
        price: "₹1049",
        image: Bridal_Set_13,
      },
      {
        id: 214,
        name: "Stunning Bridal Bangles",
        description: "Stunning bridal bangles that captivate.",
        price: "₹999",
        image: Bridal_Set_14,
      },
      {
        id: 215,
        name: "Magnificent Bridal Set",
        description: "Magnificent bridal bangles for grand weddings.",
        price: "₹999",
        image: Bridal_Set_15,
      },
      // {
      //   id: 216,
      //   name: "Radiant Bridal Collection",
      //   description: "Radiant bridal bangles that shine bright.",
      //   price: "₹1099",
      //   image: Bridal_Set_16,
      // },
      {
        id: 217,
        name: "Splendid Bridal Set",
        description: "Splendid bridal bangles with intricate details.",
        price: "₹799",
        image: Bridal_Set_17,
      },
      {
        id: 218,
        name: "Divine Bridal Bangles",
        description: "Divine bridal bangles for sacred ceremonies.",
        price: "₹599",
        image: Bridal_Set_18,
      },
      {
        id: 219,
        name: "Enchanting Bridal Set",
        description: "Enchanting bridal bangles that mesmerize.",
        price: "₹1049",
        image: Bridal_Set_19,
      },
      {
        id: 220,
        name: "Celestial Bridal Collection",
        description: "Celestial bridal bangles with heavenly beauty.",
        price: "₹799",
        image: Bridal_Set_20,
      },
      {
        id: 221,
        name: "Imperial Bridal Set",
        description: "Imperial bridal bangles fit for royalty.",
        price: "₹1299",
        image: Bridal_Set_21,
      },
    ],
  },
  "chains": {
    // Chains
    name: "Chains",
    products: [
      {
        id: 301,
        name: "Classic Chain Set",
        description: "Beautiful chain set with elegant design.",
        price: "₹349",
        image: Chain_Set,
      },
      {
        id: 302,
        name: "Premium Chain",
        description: "Designer chain with intricate patterns.",
        price: "₹449",
        image: Chain_2,
      },
      {
        id: 303,
        name: "Designer Chain",
        description: "Premium quality chain for special occasions.",
        price: "₹199",
        image: Chain_3,
      },
      {
        id: 304,
        name: "Elegant Chain",
        description: "Elegant chain perfect for any outfit.",
        price: "₹199",
        image: Chain_4,
      },
    ],
  },
  "hair-accessories": {
    // Hair Accessories
    name: "Hair Accessories",
    products: [
      {
        id: 401,
        name: "Handcrafted Thread Hair Clip(5)",
        description: "Beautifully handcrafted hair clip with colorful thread detailing.",
        price: "₹149",
        image: Hair_Clip_1,
      },
      {
        id: 402,
        name: "Floral Thread Hair Clip(5)",
        description: "Elegant floral design hair clip with intricate threadwork.",
        price: "₹149",
        image: Hair_Clip_2,
      },
      {
        id: 403,
        name: "Embellished Hair Clip(5)",
        description: "Stylish hair clip with beautiful embellishments.",
        price: "₹149",
        image: Hair_Clip_3,
      },
      {
        id: 404,
        name: "Designer Hair Clip Set",
        description: "Designer hair clip perfect for festive and casual occasions.",
        price: "₹149",
        image: Hair_Clip_4,
      },
      {
        id: 405,
        name: "Pearl Embellished Hair Clip Set",
        description: "Elegant hair clip adorned with pearl embellishments.",
        price: "₹199",
        image: Hair_Clip_5,
      },
      {
        id: 406,
        name: "Bridal Hair Clip Set",
        description: "Stunning bridal hair clip crafted for your special day.",
        price: "₹149",
        image: Hair_Clip_6,
      },
      {
        id: 407,
        name: "Traditional Hair Clip Set",
        description: "Traditional style hair clip with intricate handwork.",
        price: "₹99",
        image: Hair_Clip_7,
      },
      {
        id: 408,
        name: "Festive Hair Clip",
        description: "Vibrant festive hair clip perfect for celebrations.",
        price: "₹149",
        image: Hair_Clip_8,
      },
      {
        id: 409,
        name: "Stone Studded Hair Clip(1)",
        description: "Gorgeous hair clip with stone studded detailing.",
        price: "₹69",
        image: Hair_Clip_9,
      },
     
    ],
  },
  "invisible-chains": {
    // Invisible Chains
    name: "Invisible Chains",
    products: [
      {
        id: 501,
        name: "Classic Invisible Chain",
        description: "Delicate invisible chain perfect for everyday wear.",
        price: "₹99",
        image: Invisible_Chain_1,
      },
      {
        id: 502,
        name: "Designer Chain Set",
        description: "Elegant chain set with subtle design elements.",
        price: "₹199",
        image: Invisible_Chain_2,
      },
      {
        id: 503,
        name: "Premium Invisible Chain",
        description: "Premium quality invisible chain with fine craftsmanship.",
        price: "₹99",
        image: Invisible_Chain_3,
      },
      {
        id: 504,
        name: "Delicate Chain Collection",
        description: "Ultra-delicate chains for a sophisticated look.",
        price: "₹149",
        image: Invisible_Chain_4,
      },
      {
        id: 505,
        name: "Elegant Invisible Chain",
        description: "Elegant and subtle chain for any occasion.",
        price: "₹129",
        image: Invisible_Chain_5,
      },
      {
        id: 506,
        name: "Bridal Invisible Chain set",
        description: "Special invisible chain designed for bridal wear.",
        price: "₹749",
        image: Invisible_Chain_6,
      },
      {
        id: 507,
        name: "Traditional Chain Design",
        description: "Traditional style invisible chain with modern touch.",
        price: "₹139",
        image: Invisible_Chain_7,
      },
      {
        id: 508,
        name: "Festive Chain Collection",
        description: "Beautiful chains perfect for festive occasions.",
        price: "₹99",
        image: Invisible_Chain_8,
      },
      {
        id: 509,
        name: "Royal Invisible Chain",
        description: "Royal design invisible chain with intricate details.",
        price: "₹149",
        image: Invisible_Chain_9,
      },
      {
        id: 510,
        name: "Contemporary Chain Set",
        description: "Contemporary design for modern fashion.",
        price: "₹149",
        image: Invisible_Chain_10,
      },
      {
        id: 511,
        name: "Luxury Chain Collection",
        description: "Luxurious invisible chain with premium finish.",
        price: "₹149",
        image: Invisible_Chain_11,
      },
      {
        id: 512,
        name: "Minimalist Chain Design",
        description: "Minimalist design for everyday elegance.",
        price: "₹99",
        image: Invisible_Chain_12,
      },
      {
        id: 513,
        name: "Artistic Chain Set",
        description: "Artistic design with unique patterns.",
        price: "₹119",
        image: Invisible_Chain_13,
      },
      {
        id: 514,
        name: "Heritage Chain Collection",
        description: "Heritage design with traditional craftsmanship.",
        price: "₹149",
        image: Invisible_Chain_15,
      },
      {
        id: 515,
        name: "Elegant Pearl Chain",
        description: "Elegant chain with pearl embellishments.",
        price: "₹199",
        image: Invisible_Chain_17,
      },
      {
        id: 516,
        name: "Designer Invisible Chain",
        description: "Designer piece with sophisticated styling.",
        price: "₹199",
        image: Invisible_Chain_18,
      },
     
    ],
  },
  "saree-pins": {
    name: "Saree Pins",
    products: [
      {
        id: 601,
        name: "Saree Pin",
        description: "Elegant handcrafted saree pin to keep your drape perfectly in place with a touch of artistry.",
        price: "1 pc – ₹49 | 2 pcs – ₹89",
        image: Saree_Pin,
      },
    ],
  },
};
